import { render, staticRenderFns } from "./sp-table.vue?vue&type=template&id=35150a0f&scoped=true"
import script from "./sp-table.vue?vue&type=script&lang=js"
export * from "./sp-table.vue?vue&type=script&lang=js"
import style0 from "./sp-table.vue?vue&type=style&index=0&id=35150a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35150a0f",
  null
  
)

export default component.exports